import { EMPTY_VALUES_BY_TYPE, } from '@wix/form-fields';
export const fillEmptyValues = (form, values, recursive = true) => {
    if (!(form === null || form === void 0 ? void 0 : form.fields)) {
        return {};
    }
    return form.fields.reduce((result, field) => {
        var _a, _b, _c;
        const fieldTarget = field.target;
        if (!fieldTarget) {
            return result;
        }
        const fieldValue = values === null || values === void 0 ? void 0 : values[fieldTarget];
        const defaultValue = (_a = field.view) === null || _a === void 0 ? void 0 : _a.defaultValue;
        const fieldType = (_b = field.view) === null || _b === void 0 ? void 0 : _b.fieldType;
        const nestedForm = (_c = field.view) === null || _c === void 0 ? void 0 : _c.form;
        if (recursive && nestedForm) {
            result[fieldTarget] = fillEmptyValues(nestedForm, fieldValue, false);
        }
        else if (fieldValue !== undefined) {
            result[fieldTarget] = fieldValue;
        }
        else if (defaultValue) {
            result[fieldTarget] = defaultValue;
        }
        else if (fieldType && fieldType in EMPTY_VALUES_BY_TYPE) {
            result[fieldTarget] =
                EMPTY_VALUES_BY_TYPE[fieldType];
        }
        return result;
    }, {});
};
//# sourceMappingURL=form-values.js.map